import { lazy } from 'react';
import ShopGuard from './components/ShopGuard';

const CourseListPage = lazy(() => import('./pages/list'));
const CourseCreatePage = lazy(() => import('./sections/CourseCreateView'));
const CourseEditPage = lazy(() => import('./sections/CourseEditView'));
const LessonEditorPage = lazy(() => import('./pages/LessonEditorPage'));

const CourseSettingsPage = lazy(() => import('./pages/CourseSettingsPage'));

export const courseRoutes = {
    path: 'courses',
    element: <ShopGuard />,
    children: [
        { element: <CourseListPage />, index: true },
        { path: 'new', element: <CourseCreatePage /> },
        { path: ':id/edit', element: <CourseEditPage /> },
        { path: ':id/lesson/:lessonId/edit', element: <LessonEditorPage /> },
        { path: 'settings', element: <CourseSettingsPage /> },
    ],
};
